import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWorldviewGift from "../../../../src/content/worldview-cards-gift/donationHeader";
import "../../../../src/content/worldview-cards-gift/worldview-cards-gift.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWorldviewGift,
  React
};